import {currenciesStringToArr, getInputsForBroker, getPrimaryInputCurrency, getSwapTypes} from "./inputReader";
import {calcAjaxCall} from "./ajax";

import containerElement from "../helpers/containerElement";

const initFxCalculator = () => {
    if (!document.querySelector('.fxcalculator') || document.querySelector('.is-free-membership')) {
        return;
    }

    // add event listeners:
    let inputs = document.querySelectorAll(['.fxcalculator__input-section input', '.fxcalculator__input-section select']);
    inputs.forEach(c => {
        c.addEventListener('change', onInputChange);
    });

    document.querySelectorAll('.fxcalculator__input-section [data-field="swap-type"] select').forEach((el, index) => {
        el.addEventListener('change', onSwapTypeChange);
    });

    document.querySelectorAll('.fx-do-calculate').forEach((el, index) => {
        el.addEventListener('click', fxCalculate);
    });

    document.querySelectorAll('.fx-do-share-deal').forEach((el, index) => {
        el.addEventListener('click', fxShareDeal);
    });

    document.querySelectorAll('.fx-first-select-1').forEach((el, index) => {
        el.addEventListener('change', duplicateCurrency);
    });
    document.querySelectorAll('.fx-first-select-2').forEach((el, index) => {
        el.addEventListener('change', duplicateCurrency);
    });

}

const printOutputs = (containerEl, outputJsonResp) => {

    outputJsonResp.then(output => {

        // console.log('output:');
        // console.log(output);

        const cssPrefix = '.fxcalculator__output-scenario ';
        setOutputField(containerEl, cssPrefix, 'fund-broker-1', 'input[type=text]', output['fund_broker1']);
        setOutputField(containerEl, cssPrefix, 'fund-broker-2', 'input[type=text]', output['fund_broker2']);
        setOutputField(containerEl, cssPrefix, 'trade-cost-clears-in', 'input[type=text]', output['trade_cost_clears_in']);
        setOutputField(containerEl, cssPrefix, 'multiplier', 'input[type=text]', output['multiplier']);
        setOutputField(containerEl, cssPrefix, 'monthly-return', 'input[type=text]', output['monthly_return']);
        setOutputField(containerEl, cssPrefix, 'trade-size-1', 'input[type=text]', output['trade_size1']);
        setOutputField(containerEl, cssPrefix, 'trade-size-2', 'input[type=text]', output['trade_size2']);
        //setOutputField(containerEl, cssPrefix, 'fund-broker-1-currency', '', 'GBP');
        //setOutputField(containerEl, cssPrefix, 'fund-broker-2-currency', '', 'GBP');

        if (containerEl.querySelector('.fx-div-console')) {
            containerEl.querySelector('.fx-div-console').innerText = JSON.stringify(output['iv']);
        }
    });
}

const duplicateCurrency = (e) => {
    const containerEl = containerElement(e.target);

    if (e.target.className.indexOf('fx-first-select-1') >= 0) {
        containerEl.querySelector('.fx-second-select-1').value = e.target.value;
        containerEl.querySelector('.fx-second-select-1').dispatchEvent(new Event('change'));
    } else if (e.target.className.indexOf('fx-first-select-2') >= 0) {
        containerEl.querySelector('.fx-second-select-2').value = e.target.value;
        containerEl.querySelector('.fx-second-select-2').dispatchEvent(new Event('change'));
    }
}

const fxShareDeal = (e) => {
    const lastCalc = fxGetLastCalc(e);
    if(!lastCalc) {
        alert('Plese click the calculate button first.');
        return;
    }

    const containerEl = containerElement(e.target);
    const brokerInputs = {
        '1': getInputsForBroker(containerEl, 1),
        '2': getInputsForBroker(containerEl, 2)
    }

    const swapTypes = [
        brokerInputs['1'].swap_type,
        brokerInputs['2'].swap_type
    ];

    if(!brokerInputs['1']['broker'] || !brokerInputs['1']['broker'] ) {
        alert('Please enter the brokers before sharing.');
        return;
    }
    const resFetch = calcAjaxCall(containerEl, lastCalc, 'share_deal');

    resFetch.then((result) => {
            const output = result.json();
            //alert('Deal shared!');
            containerEl.querySelector('.deal-info-msg').innerHTML = 'Thank you for sharing this Deal!';
        }
    );
}

const fxSetLastCalc = (e, val) => {
    let container = null;
    if(typeof e ==='object' && e.target) {
        container = containerElement(e.target);
    } else {
        container = e;
    }

    container.setAttribute('data-last-calc', val);
}

const fxGetLastCalc = (e) => {
    let container = containerElement(e.target);
    const ret = container.getAttribute('data-last-calc');
    return ret;
}

/***
 * Main calc function, re-renders all outputs in a single step
 */
const fxCalculate = (e) => {
    const containerEl = containerElement(e.target);
    const brokerInputs = {
        '1': getInputsForBroker(containerEl, 1),
        '2': getInputsForBroker(containerEl, 2)
    }

    const swapTypes = [
        brokerInputs['1'].swap_type,
        brokerInputs['2'].swap_type
    ];

    if (swapTypes[0] === 'points' && swapTypes[1] === 'points') {
        updateOutputsSwapTypePointsPoints(containerEl);
    } else if (swapTypes[0] === 'percent' && swapTypes[1] === 'points') {
        updateOutputsSwapTypePercentPoints(containerEl);
    } else if (swapTypes[0] === 'points' && swapTypes[1] === 'percent') {
        updateOutputsSwapTypePointsPercent(containerEl);
    } else if (swapTypes[0] === 'percent' && swapTypes[1] === 'percent') {
        updateOutputsSwapTypePercentPercent(containerEl);
    } else if (swapTypes[0] === 'USD' && swapTypes[1] === 'points') {
        updateOutputsSwapTypeUsdPoints(containerEl);
    } else if (swapTypes[0] === 'points' && swapTypes[1] === 'USD') {
        updateOutputsSwapTypePointsUsd(containerEl);
    } else if (swapTypes[0] === 'percent' && swapTypes[1] === 'USD') {
        updateOutputsSwapTypePercentUsd(containerEl);
    } else if (swapTypes[0] === 'USD' && swapTypes[1] === 'percent') {
        updateOutputsSwapTypeUsdPercent(containerEl);
    } else if (swapTypes[0] === 'points' && swapTypes[1] === 'EUR') {
        updateOutputsSwapTypePointsEur(containerEl);
    } else if (swapTypes[0] === 'EUR' && swapTypes[1] === 'points') {
        updateOutputsSwapTypeEurPoints(containerEl);
    } else if (swapTypes[0] === 'percent' && swapTypes[1] === 'EUR') {
        updateOutputsSwapTypePercentEur(containerEl);
    } else if (swapTypes[0] === 'EUR' && swapTypes[1] === 'percent') {
        updateOutputsSwapTypeEurPercent(containerEl);
    } else if (swapTypes[0] === 'points' && swapTypes[1] === 'GBP') {
        updateOutputsSwapTypePointsGbp(containerEl);
    } else if (swapTypes[0] === 'GBP' && swapTypes[1] === 'points') {
        updateOutputsSwapTypeGbpPoints(containerEl);
    } else if (swapTypes[0] === 'percent' && swapTypes[1] === 'GBP') {
        updateOutputsSwapTypePercentGbp(containerEl);
    } else if (swapTypes[0] === 'GBP' && swapTypes[1] === 'percent') {
        updateOutputsSwapTypeGbpPercent(containerEl);
    } else if (swapTypes[0] === 'USD' && swapTypes[1] === 'USD') {
        updateOutputsSwapTypeUsdUsd(containerEl);
    } else if (swapTypes[0] === 'EUR' && swapTypes[1] === 'EUR') {
        updateOutputsSwapTypeEurEur(containerEl);
    } else if (swapTypes[0] === 'GBP' && swapTypes[1] === 'GBP') {
        updateOutputsSwapTypeGbpGbp(containerEl);
    } else {
        console.error('Cannot update outputs - scenario not implemented');
    }
}

const updateOutputsSwapTypePointsPoints = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'points-points');
    fxSetLastCalc(containerEl, 'points-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePercentPoints = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'percent-points');
    fxSetLastCalc(containerEl, 'percent-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}


const updateOutputsSwapTypePointsPercent = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'points-percent');
    fxSetLastCalc(containerEl, 'points-percent');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePercentPercent = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'percent-percent');
    fxSetLastCalc(containerEl, 'percent-percent');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeUsdPoints = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'usd-points');
    fxSetLastCalc(containerEl, 'usd-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePointsUsd = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'points-usd');
    fxSetLastCalc(containerEl, 'points-usd');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePercentUsd = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'percent-usd');
    fxSetLastCalc(containerEl, 'percent-usd');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeUsdPercent = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'usd-percent');
    fxSetLastCalc(containerEl, 'usd-percent');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePointsEur = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'points-eur');
    fxSetLastCalc(containerEl, 'points-eur');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeEurPoints = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'eur-points');
    fxSetLastCalc(containerEl, 'eur-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePercentEur = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'percent-eur');
    fxSetLastCalc(containerEl, 'percent-eur');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeEurPercent = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'eur-percent');
    fxSetLastCalc(containerEl, 'eur-percent');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}


const updateOutputsSwapTypePointsGbp = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'points-gbp');
    fxSetLastCalc(containerEl, 'points-gbp');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}


const updateOutputsSwapTypeGbpPoints = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'gbp-points');
    fxSetLastCalc(containerEl, 'gbp-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}


const updateOutputsSwapTypePercentGbp = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'percent-gbp');
    fxSetLastCalc(containerEl, 'percent-gbp');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}


const updateOutputsSwapTypeGbpPercent = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'gbp-percent');
    fxSetLastCalc(containerEl, 'gbp-percent');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeUsdUsd = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'usd-usd');
    fxSetLastCalc(containerEl, 'usd-usd');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeEurEur = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'eur-eur');
    fxSetLastCalc(containerEl, 'eur-eur');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}


const updateOutputsSwapTypeGbpGbp = (containerEl) => {

    const resFetch = calcAjaxCall(containerEl, 'gbp-gbp');
    fxSetLastCalc(containerEl, 'gbp-gbp');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const setOutputField = (containerEl, cssPrefix, fieldName, inputType, val) => {

    if (fieldName === 'monthly-return') {
        containerEl.querySelector(cssPrefix + ' .monthly-return ').innerHTML = val;
        return;
    }

    if (inputType) {
        containerEl.querySelector(cssPrefix + ' [data-field="' + fieldName + '"] ' + inputType).value = val;
    } else {
        containerEl.querySelector(cssPrefix + ' [data-label="' + fieldName + '"] ' + inputType).innerHTML = val;
    }
}

const onInputChange = (e) => {
    if (e.target.className.indexOf('select-input') >= 0) {
        return;
    }

    if (e.target.className.indexOf('excluded') >= 0) {
        return;
    }

    fxCalculate(e);
    //alert("Input changed");
}

const onSwapTypeChange = () => {
    //const swapTypes = getSwapTypes();
    //
    // if (!swapTypes) {
    //     alert('This scenario is not implemented yet!');
    //     return;
    // }

    // let activeEl = '';
    // if (swapTypes[0] === 'points' && swapTypes[1] === 'points') {
    //     activeEl = ('[data-scenario="' + 'swap-type-points-points' + '"]');
    // }/* else if (swapTypes[0] === 'percent' && swapTypes[1] === 'points') {
    //     activeEl = ('[data-scenario="' + 'swap-type-percent-points' + '"]');
    // } */else {
    //     alert('This scenario is not supported yet!');
    //     return;
    // }

    // document.querySelectorAll('.fxcalculator__output-scenario').forEach((el, index) => {
    //     el.classList.remove('active');
    // });
    // document.querySelector('.fxcalculator__output-scenario' + activeEl).classList.add('active');
}

initFxCalculator();
